import React, { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import PartnersSection from "./PartnersSection";
import { useNavigate } from "react-router-dom";
import vid from '../../../assets/whoWeAre/vide.mp4'

const WhoWeAre = () => {
  const [count, setCount] = useState(0);
  const sectionRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  const navigate = useNavigate();

  // Trigger count when in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          startCount();
          setHasAnimated(true);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [hasAnimated]);

  const startCount = () => {
    let start = 0;
    const end = 15;
    const duration = 1000;
    const stepTime = Math.abs(Math.floor(duration / end));

    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, stepTime);
  };

  return (
    <>
    <div className="font-sans text-gray-800 bg-blue-100"> 
      <section
        ref={sectionRef}
        className="relative bg-black text-white py-16 md:py-20 overflow-hidden"
      >
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          {/* Replace this with your own video file */}
          <source src={vid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Dark Overlay for readability */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-16 md:gap-36 px-4 sm:px-6">
          {/* Left */}
          <div className="flex flex-col items-center md:items-start space-y-6">
            <span className="flex items-center gap-2 text-sm sm:text-base">
              <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
              <span className="font-medium">Who we are</span>
            </span>
            <img
              src="https://framerusercontent.com/images/OQy3Iv3lQ40QKCoLU4u2Bj6cysY.png"
              alt="Abstract Shape"
              className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 object-contain animate-spin-slow-reverse"
            />
          </div>

          {/* Right */}
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-[28px] sm:text-[34px] md:text-[40px] lg:text-5xl font-normal leading-tight mb-6 md:mb-8">
              We shape metal into reliable fasteners.
            </h2>

            <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-9">
              {/* Number */}
              <div className="flex flex-col items-center md:items-start border-r-0 md:border-r-2 border-gray-300 md:pr-16">
                <div className="text-[80px] sm:text-[120px] md:text-[180px] leading-none font-semibold text-white w-48 text-center">
                  {count}+
                </div>
                <p className="text-gray-200 text-sm sm:text-base mt-2 max-w-[200px] md:max-w-none text-center md:text-left">
                  brands trusted us to scale confidently.
                </p>
              </div>

              {/* Description */}
              <div className="max-w-sm">
                <p className="text-gray-200 mb-6 text-sm sm:text-base leading-relaxed">
                  Today’s industries demand more than just bolts. They need
                  precision, strength, and reliability, That’s exactly what
                  we deliver.
                </p>
                <button
                  className="relative overflow-hidden inline-flex items-center gap-2 px-6 py-3 sm:py-4 rounded-full bg-[#000d2f] text-white font-medium group transition-colors duration-300 hover:bg-white hover:text-black"
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    navigate("/units/main");
                  }}
                >
                  <span className="relative z-10 flex items-center gap-2">
                    <span className="relative block overflow-hidden h-6">
                      {/* Top text slides up */}
                      <span className="block transition-transform duration-300 transform group-hover:-translate-y-full">
                        Explore Us More
                      </span>
                      {/* Bottom text slides in */}
                      <span className="absolute top-full left-0 w-full block transition-transform duration-300 transform group-hover:-translate-y-full">
                        Explore Us More
                      </span>
                    </span>
                    <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PartnersSection />
      </div>
    </>
  );
};

export default WhoWeAre;
